module.exports = __webpack_public_path__ + "img/BY.030b26c1.svg";